import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceDynamicsNavision = (props) => {

    const Fields = [
        {Identifier:"Username", Translation:Translate("Username"), Required:true},
        {Identifier:"Password", Translation:Translate("Password"), Required:true},
        {Identifier:"WebServiceUrl", Translation:Translate("WebService URL"), Hint:"https://********/Customer", Required:true, DefaultValue:"https://********/Customer"},
        {Identifier:"ScreenpopDomain", Translation:Translate("Screenpop URL"), Hint:"dynamicsnav://*******/runpage", Required:true, DefaultValue:"dynamicsnav://*******/runpage"}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceDynamicsNavision.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceDynamicsNavision